import { useParams } from "react-router-dom";
import { MdEdit, MdFileDownload, MdFileUpload, MdMenu } from "react-icons/md";
import { FaFolderOpen } from "react-icons/fa6";
import { FiExternalLink } from "react-icons/fi";
import { FaChevronDown, FaTimesCircle } from "react-icons/fa";
import {
  getProjectDetails,
  updateProject,
} from "../../Services/projectServices";
import toast from "react-hot-toast";
import { project_formFieldLabels, TOAST_MESSAGES } from "./constants";
import { useEffect, useState } from "react";
import * as components from "./Components";
import {
  getFormattedDate,
  getFormattedNumber,
  toProperCase,
} from "../../Utils";
import Attachment from "./Components/Attachment";
import EditPopUp from "./Components/EditPopUp";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { Spinner, RoleValidator } from "../../Components/Common";
import { ROLES } from "../../Constants/Strings";
import DonutChart from "./Components/DonutChart";

const ProjectDetails = () => {
  const { projectId } = useParams();
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showProjectPopup, setShowProjectPopup] = useState(false);
  const [showTracker, setShowTracker] = useState(false);
  const [showFiles, setShowFiles] = useState(false);
  const [getMilestone, setMilestone] = useState();
  const [currentMilestoneStatus, setCurrentMilestoneStatus] = useState("");
  const [showProjectDetails, setShowProjectDetails] = useState(false);
  const [projectFormData, setProjectFormData] = useState({
    name: projectData?.name || "N/A",
    company: projectData?.company_name || "N/A",
    capacity: getFormattedNumber(projectData?.capacity, 0) || "N/A",
    type: projectData?.type || "N/A",
    estimated_start_date:
      getFormattedDate(projectData?.estimated_start_date) || "N/A",
    estimated_end_date:
      getFormattedDate(projectData?.estimated_end_date) || "N/A",
    client_name: projectData?.client_name || "N/A",
    client_phone: projectData?.client_phone || "N/A",
    client_email: projectData?.client_email || "N/A",
    client_address: projectData?.client_address || "N/A",
    client_category: projectData?.client_category || "N/A",
    client_district: projectData?.client_district || "N/A",
    client_aadhar_number: projectData?.client_aadhar_number || "N/A",
    subsidy_vendor_name: projectData?.subsidy_vendor_name || "N/A",
    subsidy_vendor_email: projectData?.subsidy_vendor_email || "N/A",
    subsidy_vendor_phone: projectData?.subsidy_vendor_phone || "N/A",
    subsidy_vendor_representative: projectData?.subsidy_vendor_representative || "N/A",
    vendor_designation: projectData?.vendor_designation || "N/A",
    vendor_address: projectData?.vendor_address || "N/A",
    representative_designation: projectData?.representative_designation || "N/A",
    re_resource: projectData?.re_resource || "N/A",
    re_installed_capacity_rooftop: projectData?.re_installed_capacity_rooftop || "N/A",
    re_installed_capacity_rooftop_ground: projectData?.re_installed_capacity_rooftop_ground || "N/A",
    re_installed_capacity_ground: projectData?.re_installed_capacity_ground || "N/A",
    sanctioned_capacity_solar_pv_system_installed: projectData?.sanctioned_capacity_solar_pv_system_installed || "N/A",
    sanctioned_capacity: projectData?.sanctioned_capacity || "N/A",
    capacity_type: projectData?.capacity_type || "N/A",


  });
  const navigate = useNavigate();
  const [showProjectDocuments, setShowProjectDocuments] = useState(false);
  const [showDocumentTable, setShowDocumentTable] = useState(false);
  const [showDocumentUpload, setShowDocumentUpload] = useState(false);
  const [isHandover, setIsHandover] = useState(false);
const InfoField = ({ label, value, children }) => (
  <div className="flex flex-col w-[160px] md:w-full">
    {" "}
    {/* fixed width */}
    <p className="text-gray-500 text-xs w-full">{label}</p>
    <div className="font-semibold text-gray-900 break-words">
      {children || value || "N/A"}
    </div>
  </div>
);




  const fetchProjectDetails = async () => {
    setLoading(true);
    try {
      const response = await getProjectDetails(projectId);
      if (response.status === 200) {
        setProjectData(response.data);
        setProjectFormData({
          name: response.data?.name || "",
          company: response.data?.company_name || "",
          capacity: getFormattedNumber(response.data?.capacity, 0),
          type: response.data?.type,
          estimated_start_date: response.data?.estimated_start_date || "",
          estimated_end_date: response.data?.estimated_end_date || "",
          map_url: response.data?.map_url || "",
          client_name: response.data?.client_name || "",
          client_email: response.data?.client_email || "",
          client_phone: response.data?.client_phone || "",
          client_address: response.data?.client_address || "",
          client_category: response.data?.client_category || "",
          client_district: response.data?.client_district || "",
          client_aadhar_number: response.data?.client_aadhar_number || "",
          subsidy_vendor_name: response.data?.subsidy_vendor_name || "",
          subsidy_vendor_email: response.data?.subsidy_vendor_email || "",
          subsidy_vendor_phone: response.data?.subsidy_vendor_phone || "",
          subsidy_vendor_representative:
            response.data?.subsidy_vendor_representative || "",
          vendor_designation: response.data?.vendor_designation || "",
          vendor_address: response.data?.vendor_address || "",
          representative_designation:
            response.data?.representative_designation || "",
          re_resource: response.data?.re_resource || "",
          re_installed_capacity_rooftop:
            response.data?.re_installed_capacity_rooftop || "",
          re_installed_capacity_rooftop_ground:
            response.data?.re_installed_capacity_rooftop_ground || "",
          re_installed_capacity_ground:
            response.data?.re_installed_capacity_ground || "",
          sanctioned_capacity_solar_pv_system_installed:
            response.data?.sanctioned_capacity_solar_pv_system_installed || "",
          sanctioned_capacity: response.data?.sanctioned_capacity || "",
          capacity_type: response.data?.capacity_type || "",
        });
      } else {
        toast.error(TOAST_MESSAGES.PROJECT_GET_DETAILS_ERROR);
      }
    } catch (error) {
      toast.error(TOAST_MESSAGES.PROJECT_GET_DETAILS_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const project_renderFieldConfig = {
    name: { type: "TEXT" },
    company: { type: "TEXT" },
    capacity: { type: "TEXT" },
    type: {
      type: "SELECT",
      dropdownValues: ["DCR", "NON_DCR"],
    },
    estimated_start_date: { type: "DATE" },
    estimated_end_date: { type: "DATE" },
    map_url: { type: "TEXT" },
    client_name: { type: "TEXT" },
    client_phone: { type: "TEXT" },
    client_email: { type: "TEXT" },
    client_address: { type: "TEXT" },
    client_category: {
      type: "SELECT",
      dropdownValues: ["GOVERNMENT_SECTOR", "PRIVATE_SECTOR"],
    },
    client_district: { type: "TEXT" },
    client_aadhar_number: { type: "TEXT" },
    subsidy_vendor_name: { type: "TEXT" },
    subsidy_vendor_email: { type: "TEXT" },
    subsidy_vendor_phone: { type: "TEXT" },
    subsidy_vendor_representative: { type: "TEXT" },
    vendor_designation: { type: "TEXT" },
    vendor_address: { type: "TEXT" },
    representative_designation: { type: "TEXT" },
    re_resource: {
      type: "SELECT",
      dropdownValues: ["SOLAR", "WIND", "HYBRID"],
    },
    re_installed_capacity_rooftop: { type: "TEXT" },
    re_installed_capacity_rooftop_ground: { type: "TEXT" },
    re_installed_capacity_ground: { type: "TEXT" },
    sanctioned_capacity_solar_pv_system_installed: { type: "TEXT" },
    sanctioned_capacity: { type: "TEXT" },
    capacity_type: {
      type: "SELECT",
      dropdownValues: ["SINGLE_PHASE", "THREE_PHASE"],
    },
  };

  useEffect(() => {
    fetchProjectDetails();
  }, [projectId]);

  const handleSaveProject = async (updatedData) => {
    try {
      const response = await updateProject(projectData.id, updatedData);
      if(response.status === 200){

        toast.success(TOAST_MESSAGES.PROJECT_UPDATE_SUCCESS);
        setProjectFormData((prev) => ({ ...prev, ...updatedData }));
        setProjectData((prev) => ({ ...prev, ...updatedData }));
        setShowProjectPopup(false);
      } else {
        toast.error(TOAST_MESSAGES.PROJECT_UPDATE_FAILED);
      }
    } catch (error) {
      toast.error(TOAST_MESSAGES.PROJECT_UPDATE_FAILED, error);
    }
  };


  return (
    <div className=" bg-gray-50 max-h-full p-4">
      <div className="flex flex-row md:gap-4 mb-2 justify-between">
        <div className="flex gap-4 items-center">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="text-primary text-center text-sm font-lg"
          >
            <IoMdArrowRoundBack size={20} className="text-primary" />
          </button>
          <h1 className="text-xl font-bold text-primary"> Project Details</h1>
        </div>
        <div className="flex gap-4">
          <RoleValidator allowedRoles={[ROLES.ADMIN, ROLES.USER]}>
            <div className="flex gap-2">
              <button
                className="flex gap-2 p-1 items-center text-gray-500 hover:text-blue-500"
                onClick={() => {
                  setShowProjectDocuments(true);
                  setShowDocumentTable(false);
                  setShowDocumentUpload(true);
                }}
                title="Upload File"
              >
                <MdFileUpload size={20} />
              </button>
              <button
                className="flex gap-2 p-1 items-center text-yellow-500"
                onClick={() => {
                  setShowProjectDocuments(true);
                  setShowDocumentTable(true);
                  setShowDocumentUpload(false);
                }}
                title="Project Documents"
              >
                <FaFolderOpen size={20} />
              </button>
            </div>
          </RoleValidator>
          <button
            className="lg:hidden p-2 bg-gray-200 rounded-md"
            onClick={() => setShowTracker(true)}
            title="Show Tracker"
          >
            <MdMenu size={20} />
          </button>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : projectData ? (
        <>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
            <div className="grid-cols-1 lg:col-span-3 max-h-[75vh] overflow-y-scroll thin-scrollbar">
              <div className="lg:col-span-2 flex flex-col bg-white shadow rounded-md px-2 py-4 mb-4">
                <div className="flex flex-col md:flex-row w-full justify-between">
                  <div className="relative px-2">
                    <span className="text-lg font-semibold">
                      {projectData?.name}
                    </span>
                  </div>
                  <div
                    className="flex gap-3 text-sm w-full md:w-[80%] justify-between"
                    onClick={() => setShowProjectDetails(!showProjectDetails)}
                  >
                    <div className="text-gray-700">
                      Type
                      <div className="font-semibold text-gray-900">
                        {projectData?.type}
                      </div>
                    </div>
                    <div className="text-gray-700">
                      Capacity
                      <div className="font-semibold text-gray-900">
                        {getFormattedNumber(projectData?.capacity, 0)} KW
                      </div>
                    </div>
                    <div className="text-gray-700">
                      Client Name
                      <div className="font-semibold text-gray-900">
                        {projectData?.client_name}
                      </div>
                    </div>

                    <div className="flex flex-col justify-end p-2">
                      <FaChevronDown
                        className={`text-gray-500 transition-transform duration-300  ${
                          showProjectDetails ? "rotate-180" : ""
                        }`}
                        size={16}
                      />
                    </div>
                  </div>
                </div>
                {showProjectDetails && (
                  <>
                    <div className="flex justify-end gap-2">
                      <RoleValidator
                        allowedRoles={[ROLES.ADMIN, ROLES.USER]}
                        fallback={<span className="h-5"></span>}
                      >
                        <button
                          className="flex gap-2 p-1 text-primary px-4 items-center"
                          onClick={() => setShowProjectPopup(true)}
                          title="Edit Project"
                        >
                          <MdEdit size={20} />
                        </button>
                      </RoleValidator>
                    </div>

                    {/* Project Info */}
                    <div className=" rounded-lg p-4 mb-4 shadow-sm">
                      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <div className="w-full md:w-[30%]">
                          <DonutChart
                            percentage={
                              Number(
                                getFormattedNumber(
                                  projectData.project_completion_status
                                )
                              ) || 0
                            }
                            title="Project Completion"
                          />
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 text-sm w-full">
                          <InfoField
                            label="Start Date"
                            value={getFormattedDate(
                              projectData?.estimated_start_date
                            )}
                          />
                          <InfoField
                            label="Est. End Date"
                            value={getFormattedDate(
                              projectData?.estimated_end_date
                            )}
                          />
                          <InfoField
                            label="Created By"
                            value={projectData?.created_by}
                          />
                          <InfoField
                            label="Created On"
                            value={getFormattedDate(projectData?.created)}
                          />
                          <InfoField
                            label="GST Number"
                            value={projectData?.company_gst_number}
                          />
                          <InfoField
                            label="PAN Number"
                            value={projectData?.company_pan_number}
                          />

                          <InfoField
                            label="Company"
                            value={projectData?.company_name}
                          />
                          <InfoField label="Map">
                            <a
                              className=" font-semibold text-blue-500 truncate block max-w-[200px]"
                              href={projectData?.map_url}
                              title={projectData?.map_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="flex items-center gap-2">
                                Go to Map
                                <FiExternalLink />
                              </span>
                            </a>
                          </InfoField>
                        </div>
                      </div>
                    </div>

                    {/* Client Details */}
                    <div className="bg-gray-50 rounded-lg p-4 gap-4 mb-4 shadow-sm">
                      <h3 className="text-md font-semibold mb-3">
                        Client Details
                      </h3>
                      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <InfoField
                          label="Name"
                          value={projectData?.client_name}
                        />
                        <InfoField
                          label="Phone"
                          value={projectData?.client_phone}
                        />
                        <InfoField
                          label="Email"
                          value={projectData?.client_email}
                        />
                        <InfoField
                          label="Address"
                          value={projectData?.client_address}
                        />
                        <InfoField
                          label="District"
                          value={projectData?.client_district}
                        />
                        <InfoField
                          label="Category"
                          value={toProperCase(projectData?.client_category)}
                        />
                        <InfoField
                          label="Aadhar Number"
                          value={projectData?.client_aadhar_number}
                        />
                      </div>
                    </div>

                    {/* Vendor Details */}
                    <div className="bg-gray-50 rounded-lg p-4 gap-4 mb-4 shadow-sm">
                      <h3 className="text-md font-semibold mb-3">
                        Vendor Details
                      </h3>
                      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <InfoField
                          label="Vendor Name"
                          value={projectData?.subsidy_vendor_name}
                        />
                        <InfoField
                          label="Representative"
                          value={projectData?.subsidy_vendor_representative}
                        />
                        <InfoField
                          label="Designation"
                          value={projectData?.representative_designation}
                        />
                        <InfoField
                          label="Email"
                          value={projectData?.subsidy_vendor_email}
                        />
                        <InfoField
                          label="Phone"
                          value={projectData?.subsidy_vendor_phone}
                        />
                        <InfoField
                          label="Address"
                          value={projectData?.vendor_address}
                        />
                      </div>
                    </div>

                    {/* Technical Details */}
                    <div className="bg-gray-50 rounded-lg p-4 gap-4 mb-4 shadow-sm">
                      <h3 className="text-md font-semibold mb-3">
                        Technical Details
                      </h3>
                      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <InfoField
                          label="RE Resource"
                          value={projectData?.re_resource}
                        />
                        <InfoField
                          label="Capacity Type"
                          value={toProperCase(projectData?.capacity_type)}
                        />
                        <InfoField
                          label="Sanctioned Capacity (KW)"
                          value={getFormattedNumber(
                            projectData?.sanctioned_capacity
                          )}
                        />
                        <InfoField
                          label="Sanctioned Capacity Installed (KW)"
                          value={getFormattedNumber(
                            projectData?.sanctioned_capacity_solar_pv_system_installed
                          )}
                        />
                        <InfoField
                          label="Installed Capacity Ground (KW)"
                          value={getFormattedNumber(
                            projectData?.re_installed_capacity_ground
                          )}
                        />
                        <InfoField
                          label="Installed Capacity Rooftop (KW)"
                          value={getFormattedNumber(
                            projectData?.re_installed_capacity_rooftop
                          )}
                        />
                        <InfoField
                          label="Installed Capacity Rooftop + Ground (KW)"
                          value={getFormattedNumber(
                            projectData?.re_installed_capacity_rooftop_ground
                          )}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
              <components.PaymentCard
                currentMilestoneStatus={currentMilestoneStatus}
              />
              <components.ProjectContactCard
                project_id={projectId}
                projectData={projectData}
              />
            </div>

            {/* tracker for the web view */}
            <div className="hidden lg:block space-y-6 max-h-[75vh]">
              <div className="bg-white shadow rounded-sm h-full flex flex-col">
                <h2 className="font-semibold mb-3 border-b-2 text-md py-2 px-4">
                  Tracker
                </h2>
                <div className="p-4 flex-1 overflow-auto thin-scrollbar">
                  <components.MilestonesTracker
                    setShowFiles={setShowFiles}
                    setMilestone={setMilestone}
                    setIsHandover={setIsHandover}
                    setCurrentMilestoneStatus={setCurrentMilestoneStatus}
                  />
                </div>
              </div>
            </div>
          </div>

          {showTracker && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center p-4">
              <div className="bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-auto ">
                <div className="flex justify-between items-center border-b p-4 sticky top-0 bg-white z-10">
                  <h2 className="font-semibold">Tracker</h2>
                  <button
                    className="p-2 text-gray-900 rounded-md"
                    onClick={() => setShowTracker(false)}
                  >
                    <FaTimesCircle size={25} />
                  </button>
                </div>
                <div className="p-4">
                  <components.MilestonesTracker
                    setShowFiles={setShowFiles}
                    setMilestone={setMilestone}
                    setIsHandover={setIsHandover}
                    setCurrentMilestoneStatus={setCurrentMilestoneStatus}
                  />
                </div>
              </div>
            </div>
          )}

          {showFiles && !isHandover && (
            <Attachment
              onClose={() => setShowFiles(false)}
              getMilestone={getMilestone}
              currentMilestoneStatus={currentMilestoneStatus}
            />
          )}

          {showProjectPopup && (
            <EditPopUp
              onClose={() => setShowProjectPopup(false)}
              onSave={handleSaveProject}
              formData={projectFormData}
              renderFieldConfig={project_renderFieldConfig}
              formLabelFields={project_formFieldLabels}
              isThreeColumnCSS={"w-1/2 md:w-1/3 px-4"}
              setFormData={setProjectFormData}
            />
          )}

          {(showProjectDocuments || isHandover) && (
            <components.ProjectDocuments
              onClose={() => {
                setShowProjectDocuments(false);
                setIsHandover(false);
                setShowFiles(false);
              }}
              showDocumentsTable={isHandover ? true : showDocumentTable}
              showDocumentUpload={isHandover ? false : showDocumentUpload}
              showProjectDocuments={showProjectDocuments}
              setShowProjectDocuments={setShowProjectDocuments}
              showHandover={isHandover}
              currentMilestoneStatus={currentMilestoneStatus}
            />
          )}
        </>
      ) : (
        <div className="p-6 text-center text-red-500 text-lg">
          No project details found.
        </div>
      )}
    </div>
  );
};

export default ProjectDetails;
